import { LogoPropsType } from './logoTypes';

export default function ASMLLogo({ className }: LogoPropsType) {
  return (
    <svg viewBox="0 0 300 83" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <title id="asmlLogoTitle">ASML</title>
      <g clipPath="url(#clip0_4178_119107)">
        <path
          d="M202.275 80.3839L212.775 31.3316L216.75 80.3839H239.4L228.9 2.46853H204.75L193.425 49.2028L182.1 2.46853H157.875L147.375 80.3839H170.025L174.075 31.3316L184.575 80.3839H202.275ZM249.975 2.46853V80.3839H300V64.0082H271.125V2.46853H249.975ZM24.375 2.46853L0 80.3839H24.375L27.6 66.3262H48.675L51.9 80.3839H76.275L51.975 2.46853H24.375ZM38.175 19.6667L45.45 51.5956H30.825L38.175 19.6667ZM132.75 24.5271C112.575 7.32889 81 14.3577 80.7 30.0604C76.125 0.823491 112.425 -5.23327 132.75 3.96403C133.125 8.67484 133.5 13.6848 132.75 24.5271ZM115.95 33.7992C124.275 36.9397 139.2 40.9775 139.2 57.6523C139.2 67.9712 129 77.5424 117.15 81.1316C102.525 85.4685 87.975 81.2064 78.975 77.4676V58.4748C86.55 63.7091 93.15 66.4757 101.4 66.7001C106.35 66.7748 113.925 64.3821 113.925 57.7271C113.925 52.0442 108.45 50.2496 105.375 48.6046C87.375 39.0334 92.775 19.8163 109.05 18.246C104.325 19.7415 103.35 22.2839 103.35 24.5271C103.5 30.1352 110.925 31.855 115.95 33.7992Z"
          fill="#808080"
        />
      </g>
      <defs>
        <clipPath id="clip0_4178_119107">
          <rect width="300" height="83" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
